
import { value } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { printf, toFail } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { append, indexed, item as item_1, tryFind, collect, filter, concat, map as map_2, mapIndexed, toArray, singleton, fold, empty, cons, tail, head, isEmpty } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { toArray as toArray_1, toList, add, FSharpMap__get_Item, tryFind as tryFind_1, ofList, empty as empty_1, FSharpMap__Add, FSharpMap__TryFind } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { Exception, compareArrays, stringHash, equals, compare } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { SimGraph_add, SimGraph_find, SimGraph_foldValues, SimGraph_ofList, SimulationComponent, SimulationComponentState } from "./SimGraphTypes.js";
import { convertIntToFastData } from "./NumberHelpers.js";
import { fixedOf } from "./RamStore.js";
import { toString } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { Connection, ComponentType } from "../Common/CommonTypes.js";
import { cToInt, pToInt } from "../Common/Ids.js";
import { sortBy, map as map_3, item, mapIndexed as mapIndexed_1 } from "../fable_modules/fable-library-js.5.13.0/Array.js";
import { op_UnaryNegation_Int32 } from "../fable_modules/fable-library-js.5.13.0/Int32.js";
import { List_groupBy } from "../fable_modules/fable-library-js.5.13.0/Seq2.js";
import { analyseState } from "./CanvasStateAnalyser.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.5.13.0/Result.js";

function getPortNumberOrFail(port) {
    if (port != null) {
        return value(port);
    }
    else {
        return toFail(printf("what? Component ports should always have a portNumber"));
    }
}

function getValuesForPorts(inputs, portNumbers) {
    if (!isEmpty(portNumbers)) {
        const matchValue = FSharpMap__TryFind(inputs, head(portNumbers));
        if (matchValue != null) {
            const wireData = matchValue;
            const matchValue_1 = getValuesForPorts(inputs, tail(portNumbers));
            if (matchValue_1 != null) {
                return cons(wireData, matchValue_1);
            }
            else {
                return undefined;
            }
        }
        else {
            return undefined;
        }
    }
    else {
        return empty();
    }
}

function buildSourceToTargetPortMap(connections) {
    return fold((map, conn) => {
        let matchValue;
        const key = conn.Source.Id;
        const target = [conn.Target.HostId, conn.Target.Id];
        return FSharpMap__Add(map, key, (matchValue = FSharpMap__TryFind(map, key), (matchValue != null) ? cons(target, matchValue) : singleton(target)));
    }, empty_1({
        Compare: (x, y) => (compare(x, y) | 0),
    }), connections);
}

function mapInputPortIdToPortNumber(components) {
    return fold((map, comp) => fold((map_1, port) => FSharpMap__Add(map_1, port.Id, getPortNumberOrFail(port.PortNumber)), map, comp.InputPorts), empty_1({
        Compare: (x, y) => (compare(x, y) | 0),
    }), components);
}

function getDefaultState(compType_1) {
    let matchResult, w, memory;
    switch (compType_1.tag) {
        case 48: {
            matchResult = 1;
            break;
        }
        case 50:
        case 51:
        case 52:
        case 53: {
            matchResult = 2;
            break;
        }
        case 54:
        case 55: {
            matchResult = 3;
            break;
        }
        case 0:
        case 1:
        case 3:
        case 4:
        case 6:
        case 47:
        case 5:
        case 8:
        case 10:
        case 11:
        case 12:
        case 13:
        case 9:
        case 25:
        case 14:
        case 15:
        case 16:
        case 17:
        case 24:
        case 21:
        case 22:
        case 23:
        case 26:
        case 27:
        case 29:
        case 28:
        case 30:
        case 40:
        case 2:
        case 18:
        case 19:
        case 20:
        case 46: {
            matchResult = 4;
            break;
        }
        case 7:
        case 49: {
            matchResult = 5;
            break;
        }
        case 39: {
            matchResult = 6;
            break;
        }
        case 31:
        case 32: {
            matchResult = 7;
            break;
        }
        case 33: {
            matchResult = 8;
            w = compType_1.fields[0];
            break;
        }
        case 34: {
            matchResult = 8;
            w = compType_1.fields[0];
            break;
        }
        case 35: {
            matchResult = 8;
            w = compType_1.fields[0];
            break;
        }
        case 37: {
            matchResult = 8;
            w = compType_1.fields[0];
            break;
        }
        case 36: {
            matchResult = 8;
            w = compType_1.fields[0];
            break;
        }
        case 38: {
            matchResult = 8;
            w = compType_1.fields[0];
            break;
        }
        case 41: {
            matchResult = 9;
            memory = compType_1.fields[0];
            break;
        }
        case 42: {
            matchResult = 9;
            memory = compType_1.fields[0];
            break;
        }
        default:
            matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return toFail(printf("What? Legacy RAM component types should never occur"));
        case 1:
            return toFail(printf("Legacy Input component types should never occur"));
        case 2:
            return toFail(printf("What? Array sheet IO is removed by expansion and should never reach the simulator"));
        case 3:
            return SimulationComponentState.NoState;
        case 4:
            return SimulationComponentState.NoState;
        case 5:
            return SimulationComponentState.NoState;
        case 6:
            return SimulationComponentState.NoState;
        case 7:
            return new SimulationComponentState(/* DffState */ 1, [0]);
        case 8:
            return new SimulationComponentState(/* RegisterState */ 2, [convertIntToFastData(w, 0)]);
        default:
            return new SimulationComponentState(/* RamState */ 3, [fixedOf(memory)]);
    }
}

export function compType(t) {
    if (t.tag === 26) {
        return t.fields[0].Name;
    }
    else {
        return toString(t);
    }
}

function buildSimulationComponent(sourceToTargetPort, portIdToPortNumber, comp, outputWidths) {
    const outputs = toArray(mapIndexed((k, port_1) => {
        const matchValue_2 = getPortNumberOrFail(port_1.PortNumber) | 0;
        if (matchValue_2 === k) {
            const port = port_1;
            const matchValue_1 = FSharpMap__TryFind(sourceToTargetPort, port.Id);
            if (matchValue_1 != null) {
                return map_2((tupledArg) => {
                    const portId = tupledArg[1];
                    const matchValue = FSharpMap__TryFind(portIdToPortNumber, portId);
                    if (matchValue != null) {
                        return [tupledArg[0], matchValue];
                    }
                    else {
                        return toFail(printf("what? Input port with portId %A has no portNumber associated"))(portId);
                    }
                }, matchValue_1);
            }
            else if (equals(comp.Type, ComponentType.IOLabel)) {
                return empty();
            }
            else {
                const arg_1 = pToInt(port.Id) | 0;
                const arg_2 = cToInt(comp.Id) | 0;
                return toFail(printf("what? Unconnected output port %d in comp %d"))(arg_1)(arg_2);
            }
        }
        else {
            const arg_4 = cToInt(comp.Id) | 0;
            return toFail(printf("what? output port at position %d of comp %d is numbered %d"))(k)(arg_4)(matchValue_2);
        }
    }, comp.OutputPorts));
    let drivenInputs;
    const inputs = concat(mapIndexed_1((x, inpL) => map_2((inpPort) => [inpPort, item(x, outputWidths)], inpL), outputs));
    drivenInputs = ((comp.Type.tag === 1) ? cons([[comp.Id, 0], 1], inputs) : inputs);
    let outputWidths_1;
    const matchValue_4 = comp.Type;
    let matchResult, width_1;
    switch (matchValue_4.tag) {
        case 1: {
            matchResult = 0;
            width_1 = matchValue_4.fields[0];
            break;
        }
        case 2: {
            matchResult = 0;
            width_1 = matchValue_4.fields[0];
            break;
        }
        default:
            matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            outputWidths_1 = (new Int32Array([width_1]));
            break;
        }
        default:
            outputWidths_1 = outputWidths;
    }
    return new SimulationComponent(comp.Id, comp.Type, comp.Label, outputs, drivenInputs, empty_1({
        Compare: (x_1, y) => (compare(x_1, y) | 0),
    }), outputWidths_1, undefined);
}

export function getLabelConnections(comps, conns) {
    const labels = filter((co) => equals(co.Type, ComponentType.IOLabel), comps);
    ofList(map_2((co_1) => [co_1.Id, co_1], labels), {
        Compare: (x, y) => (compare(x, y) | 0),
    });
    const targetMap = ofList(map_2((conn) => [conn.Target.HostId, conn], conns), {
        Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
    });
    return collect((tupledArg) => {
        const lst = tupledArg[1];
        let dConn;
        const _arg = tryFind((co_2) => !equals(tryFind_1(co_2.Id, targetMap), undefined), lst);
        dConn = ((_arg != null) ? FSharpMap__get_Item(targetMap, _arg.Id) : toFail(printf("What? component cannot be found in %A"))(targetMap));
        return map_2((tupledArg_1) => {
            const conn_1 = dConn;
            const Target = item_1(0, tupledArg_1[1].InputPorts);
            return new Connection(op_UnaryNegation_Int32(((conn_1.Id * 1000) + tupledArg_1[0]) + 1), conn_1.Source, Target, conn_1.Vertices);
        }, indexed(filter((co_4) => !equals(co_4.Id, dConn.Target.HostId), lst)));
    }, List_groupBy((co_3) => co_3.Label, labels, {
        Equals: (x_2, y_2) => (x_2 === y_2),
        GetHashCode: (x_2) => (stringHash(x_2) | 0),
    }));
}

function buildSimulationGraph(canvasState_, canvasState__1, outputWidths) {
    const canvasState = [canvasState_, canvasState__1];
    const connections$0027 = canvasState[1];
    const components = canvasState[0];
    const sourceToTargetPort = buildSourceToTargetPortMap(append(getLabelConnections(components, connections$0027), connections$0027));
    const portIdToPortNumber = mapInputPortIdToPortNumber(components);
    const comps = SimGraph_ofList(map_2((comp_2) => [comp_2.Id, buildSimulationComponent(sourceToTargetPort, portIdToPortNumber, comp_2, map_3((tuple_1) => (tuple_1[1] | 0), sortBy((tuple) => tuple[0], map_3((tupledArg_2) => [tupledArg_2[0][1], tupledArg_2[1]], outputWidths.filter((tupledArg_1) => equals(tupledArg_1[0][0], comp_2.Id))), {
        Compare: (x, y) => (compare(x, y) | 0),
    }), Int32Array))], components));
    return SimGraph_foldValues((comps_1, comp) => fold((comps_2, tupledArg) => {
        const _arg = tupledArg[0];
        const cid = _arg[0];
        const compWithInput = SimGraph_find(cid, comps_2);
        return SimGraph_add(cid, new SimulationComponent(compWithInput.Id, compWithInput.Type, compWithInput.Label, compWithInput.Outputs, compWithInput.DrivenInputWidths, add(_arg[1], tupledArg[1], compWithInput.InputWidths), compWithInput.OutputWidths, compWithInput.CustomSimulationGraph), comps_2);
    }, comps_1, comp.DrivenInputWidths), comps, comps);
}

function findOutputWidths(canvasState_, canvasState__1, connsWidth) {
    const canvasState = [canvasState_, canvasState__1];
    const conns = canvasState[1];
    const comps = canvasState[0];
    const connsWidth_1 = map_2((tupledArg) => [tupledArg[0], value(tupledArg[1])], toList(connsWidth));
    return toArray_1(ofList(append(map_2((tupledArg_2) => {
        const connId_1 = tupledArg_2[0];
        const _arg = tryFind((tupledArg_3) => equals(connId_1, tupledArg_3[0]), connsWidth_1);
        if (_arg == null) {
            return toFail(printf("what? connection %A not found"))(connId_1);
        }
        else {
            return [[tupledArg_2[1], 0], _arg[1]];
        }
    }, filter((tupledArg_1) => {
        if (value(tryFind((c) => equals(c.Id, tupledArg_1[1]), comps)).Type.tag === 3) {
            return true;
        }
        else {
            return false;
        }
    }, map_2((conn) => [conn.Id, conn.Target.HostId], conns))), map_2((tupledArg_5) => {
        const conn_3 = tupledArg_5[0];
        const w_4 = tupledArg_5[1] | 0;
        const matchValue_2 = conn_3.Source.PortNumber;
        if (matchValue_2 == null) {
            return [[conn_3.Source.HostId, value(value(tryFind((p) => equals(p.Id, conn_3.Source.Id), value(tryFind((c_1) => equals(c_1.Id, conn_3.Source.HostId), comps)).OutputPorts)).PortNumber)], w_4];
        }
        else {
            return [[conn_3.Source.HostId, matchValue_2], w_4];
        }
    }, map_2((tupledArg_4) => {
        const id_2 = tupledArg_4[0];
        const matchValue_1 = tryFind((conn_1) => equals(conn_1.Id, id_2), conns);
        if (matchValue_1 != null) {
            return [matchValue_1, tupledArg_4[1]];
        }
        else {
            return toFail(printf("what? connection %A not found"))(id_2);
        }
    }, connsWidth_1))), {
        Compare: (x, y) => (compareArrays(x, y) | 0),
    }));
}

/**
 * Validate a diagram and generate its simulation graph.
 */
export function runCanvasStateChecksAndBuildGraph(canvasState_, canvasState__1, loadedComponents) {
    const canvasState = [canvasState_, canvasState__1];
    const matchValue = analyseState(canvasState[0], canvasState[1], loadedComponents);
    if (matchValue[0] == null) {
        if (matchValue[1] == null) {
            throw new Exception("This should not happen, connections width should be available if no error was found.");
        }
        else {
            return new FSharpResult$2(/* Ok */ 0, [buildSimulationGraph(canvasState[0], canvasState[1], findOutputWidths(canvasState[0], canvasState[1], matchValue[1]))]);
        }
    }
    else {
        return new FSharpResult$2(/* Error */ 1, [matchValue[0]]);
    }
}

/**
 * Get ComponentIds, ComponentLabels and wire widths of all input and output
 * nodes.
 */
export function getSimulationIOs(components) {
    return fold((tupledArg, comp) => {
        const inputs = tupledArg[0];
        const outputs = tupledArg[1];
        const matchValue = comp.Type;
        switch (matchValue.tag) {
            case 0:
                return [cons([comp.Id, comp.Label, matchValue.fields[0]], inputs), outputs];
            case 1:
                return [inputs, cons([comp.Id, comp.Label, matchValue.fields[0]], outputs)];
            default:
                return [inputs, outputs];
        }
    }, [empty(), empty()], components);
}

